import { render, staticRenderFns } from "./BasePwdPayModify.vue?vue&type=template&id=5cbd58ce&scoped=true"
import script from "./BasePwdPayModify.vue?vue&type=script&lang=js"
export * from "./BasePwdPayModify.vue?vue&type=script&lang=js"
import style0 from "./BasePwdPayModify.vue?vue&type=style&index=0&id=5cbd58ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbd58ce",
  null
  
)

export default component.exports